import { Box, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ItemAvailabilityStatus } from 'entities/CatalogItem/lib/itemAvailability';
import { FindReplacementLink } from 'shared/ui/FindReplacementLink/FindReplacementLink';

export interface UnavailableTooltipContentProps {
    availabilityStatus?: ItemAvailabilityStatus;
    onLearnMore?: () => void;
    hideReplacementLink?: boolean;
}

export const UnavailableTooltipContent = ({
    availabilityStatus,
    onLearnMore,
    hideReplacementLink = false,
}: UnavailableTooltipContentProps) => {
    const { t } = useTranslation();

    if (availabilityStatus === ItemAvailabilityStatus.NO_SUPPLIERS) {
        return (
            <Box>
                <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 600, marginBottom: '8px' }}
                >
                    {t('No Longer Available')}
                </Typography>
                <Typography typography="openSans.caption" sx={{ mb: '8px' }}>
                    {t(
                        'This item is no longer carried by suppliers. Shop similar items to find alternatives.',
                    )}
                </Typography>
                {!hideReplacementLink && (
                    <FindReplacementLink
                        sx={{
                            color: 'inherit',
                            textDecoration: 'underline',
                            fontSize: '12px',
                        }}
                    />
                )}
            </Box>
        );
    }

    return (
        <Box>
            <Typography
                variant="subtitle2"
                sx={{ fontWeight: 600, marginBottom: '8px' }}
            >
                {t('Active Supplier Required')}
            </Typography>
            <Typography typography="openSans.caption" sx={{ mb: '8px' }}>
                {t(
                    'To add this item, you need an active account with one of the suppliers.',
                )}
            </Typography>
            {onLearnMore && (
                <Link
                    component="button"
                    type="button"
                    onClick={(e) => {
                        e.stopPropagation();
                        onLearnMore();
                    }}
                    sx={{
                        color: 'inherit',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        fontSize: '12px',
                    }}
                >
                    {t('Learn more')}
                </Link>
            )}
        </Box>
    );
};
